import { Component, inject, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { getTemperatureType } from '../../../../../helper/temperature';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import { NlToBrPipe } from '../../../../../../../pipes/nl-to-br.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { brandOverride } from '../../../../../ECoSystemsHelper';

@Component({
  selector: 'app-p00037-esppolarite',
  templateUrl: './p00037-esppolarite.component.html',
  styleUrls: ['./p00037-esppolarite.component.scss'],
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    NlToBrPipe,
    TranslatePipe,
  ],
})
export class P00037ESPPolariteComponent {
  private modalController: ModalController = inject(ModalController);

  constructor() {}

  async dismissModal() {
    await this.modalController.dismiss();
  }

  protected readonly getTemperatureType = getTemperatureType;
  protected readonly brandOverride = brandOverride;
}
